import { render, staticRenderFns } from "./EmailContent.vue?vue&type=template&id=11cd7b90&scoped=true&"
import script from "./EmailContent.vue?vue&type=script&lang=js&"
export * from "./EmailContent.vue?vue&type=script&lang=js&"
import style0 from "./EmailContent.vue?vue&type=style&index=0&id=11cd7b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cd7b90",
  null
  
)

export default component.exports